/**
 * Zentrale Datums-/Zeitformatierung für die App.
 * Immer Europe/Berlin (MEZ/MESZ) – unabhängig vom Server/Browser-Timezone.
 */

const BERLIN = 'Europe/Berlin';
const LOCALE = 'de-DE';

/** Datum + Uhrzeit: "06.03.2026, 04:14" */
export const formatDateTime = (dateStr, opts = {}) => {
  if (!dateStr) return '–';
  return new Date(dateStr).toLocaleString(LOCALE, {
    timeZone: BERLIN,
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
    ...opts,
  });
};

/** Datum + Uhrzeit kurz: "06.03.26, 04:14" */
export const formatDateTimeShort = (dateStr, opts = {}) => {
  if (!dateStr) return '–';
  return new Date(dateStr).toLocaleString(LOCALE, {
    timeZone: BERLIN,
    day: '2-digit', month: '2-digit', year: '2-digit',
    hour: '2-digit', minute: '2-digit',
    ...opts,
  });
};

/** Nur Datum: "06.03.2026" */
export const formatDate = (dateStr, opts = {}) => {
  if (!dateStr) return '–';
  return new Date(dateStr).toLocaleDateString(LOCALE, {
    timeZone: BERLIN,
    day: '2-digit', month: '2-digit', year: 'numeric',
    ...opts,
  });
};

/** Nur Zeit: "04:14" */
export const formatTime = (dateStr, opts = {}) => {
  if (!dateStr) return '–';
  return new Date(dateStr).toLocaleTimeString(LOCALE, {
    timeZone: BERLIN,
    hour: '2-digit', minute: '2-digit',
    ...opts,
  });
};

/** Tag + Monat + Uhrzeit: "06.03. 04:14" */
export const formatDayTime = (dateStr) => {
  if (!dateStr) return '–';
  return new Date(dateStr).toLocaleString(LOCALE, {
    timeZone: BERLIN,
    day: '2-digit', month: '2-digit',
    hour: '2-digit', minute: '2-digit',
  });
};
